import React from 'react'
import VirtualList from '../../../components/VirtualList'
import { ReactComponent as NoNetworkIndicator } from 'media/icons/nonetwork.svg'
import styles from '../DataTable.module.scss'

// this requires class component because with function component on `loadMore` it will reset scroll position
const withVirtualBody = Component => {
	class VirtualBodyWrap extends React.Component {
		TbodyComponent = ({ children, style }) => {
			const { error, refetch, loading, loadNextPage, data, hasNextPage, hasPreviousPage, loadPreviousPage, getScrollStartIndex, itemSize } = this.props
			const displayRetryer = !loading && error

			const itemRenderer = ({ index, style: itemStyle }) => (
				<div style={itemStyle}>
					{children[0][index]}
				</div>
			)

			const loadRetry = async () => {
				if(error.fetchMoreError) {
					loadNextPage()
				} else {
					refetch()
				}
			}

			return(
				<div style={{ ...style, height: '100%', overflowY: 'hidden' }} className='rt-tbody'>
					<VirtualList
						itemRenderer={itemRenderer}
						itemCount={data.length}
						startFromIndex={getScrollStartIndex ? getScrollStartIndex(data) : 0}
						itemSize={itemSize ? itemSize : 36}
						dataLoadOffset={40}
						className={styles.virtualList}
						getScrollStartIndex={getScrollStartIndex}
						loading={loading}
						error={error}
						hasNextPage={hasNextPage}
						hasPreviousPage={hasPreviousPage}
						loadNextPage={loadNextPage}
						loadPreviousPage={loadPreviousPage}
					/>
					{displayRetryer &&
						<div className={styles.networkError} onClick={loadRetry}>
							<NoNetworkIndicator/>
							<p>Laden fehlgeschlagen. Klicken Sie hier, um es erneut zu versuchen</p>
						</div>
					}
				</div>
			)
		}
		render({ loadMore, ...rest } = this.props) {
			return(
				<Component {...rest} TbodyComponent={this.TbodyComponent}/>
			)
		}
	}
	return VirtualBodyWrap
}
export default withVirtualBody
